import { render, staticRenderFns } from "./EfsMdMaterialForm.vue?vue&type=template&id=2a3e51e3&"
import script from "./EfsMdMaterialForm.vue?vue&type=script&lang=js&"
export * from "./EfsMdMaterialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports